import React from 'react';
import { motion } from 'framer-motion';
import { Zap, MessageSquare, Download } from 'lucide-react';
const features = [{
  icon: Zap,
  title: 'Instant Generation',
  description: 'From prompt to pixel-perfect mockup in milliseconds. Our engine understands design context instantly.'
}, {
  icon: MessageSquare,
  title: 'Smart Iterations',
  description: "Refine your designs with natural language. 'Make it darker', 'Add more whitespace', 'Swap the image'."
}, {
  icon: Download,
  title: 'Export Anywhere',
  description: 'Seamlessly export to Figma, Sketch, or high-res PNG/SVG. Your workflow remains uninterrupted.'
}];
export function Features() {
  return <section id="features" className="py-24 px-6 relative bg-[#0a0a0a]" data-id="element-25">
      <div className="max-w-7xl mx-auto" data-id="element-26">
        <div className="mb-16" data-id="element-27">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-28">
            Powering the next
            <br data-id="element-29" />
            generation of design.
          </h2>
          <div className="h-1 w-20 bg-[#ff6b35]" data-id="element-30" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-31">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-8 border border-[#222] rounded-2xl bg-[#0f0f0f] hover:border-[#ff6b35]/50 transition-colors duration-300" data-id="element-32">
              <div className="w-12 h-12 bg-[#1a1a1a] rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#ff6b35] transition-colors duration-300" data-id="element-33">
                <feature.icon className="w-6 h-6 text-[#f5f5f5] group-hover:text-white" data-id="element-34" />
              </div>
              <h3 className="text-xl font-bold mb-3 font-['Syne']" data-id="element-35">
                {feature.title}
              </h3>
              <p className="text-[#a3a3a3] leading-relaxed" data-id="element-36">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}